export type UploadStatus = 'pending' | 'uploading' | 'success' | 'error' | 'canceled';

export interface UploadFileMeta {
  file: File;
  progress: number;
  status: UploadStatus;
  controller?: AbortController;
  entityId?: string;
}

export interface FinalizeUploadRequestOptions {
  // deprecated
  key?: string;
  url?: string;
  // new
  fileExtension?: string;
  upload_url?: string;
  storage_id?: string;

  // common
  method?: 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  entityId?: string | number;
  body?: Record<string, unknown>;
  token: string;
  title?: string;
  signal?: AbortSignal;
  onProgress?: (percent: number) => void;
};

export interface PresignedDataResponse {
  //deprecated
  url?: string;
  key?: string;
  bucket?: string;
  // new
  upload_url?: string;
  storage_id?: string;
}

export const UploadFileTypes = {
  IMAGE: 1,
  PDF: 2,
} as const;

export const UploadFileWorkspaces = {
  PASSPORT: 1,
  FLIGHTS: 2,
} as const;

export type UploadFileType = (typeof UploadFileTypes)[keyof typeof UploadFileTypes];
export type UploadFileWorkspace = (typeof UploadFileWorkspaces)[keyof typeof UploadFileWorkspaces];

export type FinalizeUploadRequest = (options: Partial<FinalizeUploadRequestOptions>) => Promise<unknown>;
